export function getDiaIDsAndInfo(diaMol, canonizedDiaIDs) {
    const newDiaIDs = [];
    const molecule = diaMol.moleculeWithH;
    const counts = {};
    for (const diaID of canonizedDiaIDs) {
        if (!counts[diaID]) {
            counts[diaID] = 0;
        }
        counts[diaID]++;
    }
    for (let i = 0; i < canonizedDiaIDs.length; i++) {
        const diaID = canonizedDiaIDs[diaMol.finalRanks[i]];
        const newDiaID = {
            idCode: diaID,
            attachedHydrogensIDCodes: [],
            nbAttachedHydrogens: 0,
            atomLabel: molecule.getAtomLabel(i),
            nbEquivalentAtoms: counts[diaID],
            heavyAtom: undefined,
            atomMapNo: molecule.getAtomMapNo(i),
        };
        if (molecule.getAtomicNo(i) === 1) {
            const atom = molecule.getConnAtom(i, 0);
            newDiaID.heavyAtom = canonizedDiaIDs[diaMol.finalRanks[atom]];
        }
        for (let j = 0; j < molecule.getAllConnAtoms(i); j++) {
            const atom = molecule.getConnAtom(i, j);
            if (molecule.getAtomicNo(atom) === 1) {
                newDiaID.nbAttachedHydrogens++;
                const hydrogenDiaID = canonizedDiaIDs[diaMol.finalRanks[atom]];
                if (!newDiaID.attachedHydrogensIDCodes.includes(hydrogenDiaID)) {
                    newDiaID.attachedHydrogensIDCodes.push(hydrogenDiaID);
                }
            }
        }
        newDiaIDs.push(newDiaID);
    }
    return newDiaIDs;
}
//# sourceMappingURL=getDiaIDsAndInfo.js.map